module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av567-50c4214ca0b3277c4ea5f83a4cb19f50.jpg";